import ObjArrUtils from "@/utils/ObjArrUtils";
import { Base, BREAD, error } from "@/store/base/module";
import ApiUtils from "@/plugins/ApiPlugin/ApiUtils";

const module = {
  state: {
    PageConst: {
      ACTION: {
        doBrowse: { api: "M0010SettingService.M21201_doBrowse" },
        doRead: { api: "M0010SettingService.M21201_getEdit" },
        doAdd: { api: "M0010SettingService.M21201_doAdd" },
        doEdit: { api: "M0010SettingService.M21201_doEdit" },
      },
    },
    defaultDoBrowse: {
      searchInfo: {},
      orderBy: [],
    },
  },
  actions: {
    async M21201_doBrowse_AtDataTable({ commit, state }) {
      const pagination = state.pagination || { current_page: 1, per_page: 30 };
      const input = {
        searchInfo: state.searchInfo || {},
        orderBy: state.orderBy || [],
        pagination: {
          ...pagination,
          offset: (pagination.current_page - 1) * pagination.per_page,
        },
      };
      const res = await ApiUtils.postData({
        data: [
          {
            api: state.PageConst.ACTION.doBrowse.api,
            input,
          },
        ],
      });

      const output =
        res?.[0]?.output ??
        res?.doBrowse?.output ??
        res?.doBrowse ??
        res?.output ??
        res;
      const rows = Array.isArray(output)
        ? output
        : (output?.data ?? output?.rows ?? output?.items ?? output?.list ?? []);
      const paginationResult = output?.pagination ?? {
        ...input.pagination,
        current_page: input.pagination?.current_page ?? 1,
        per_page: input.pagination?.per_page ?? 30,
        total: rows.length,
      };

      commit("SET_ROWS", rows);
      commit("SET_PAGINATION", paginationResult);
      commit("setState", {
        doBrowseStatus:
          (paginationResult.total ?? rows.length) > 0 ? "loaded" : "noData",
      });

      return output;
    },
    async doBrowse(_ctx, payload = {}) {
      const res = await ApiUtils.postData({
        data: [
          {
            api: "M0010SettingService.M21201_doBrowse",
            input: payload || {},
          },
        ],
      });
      return res;
    },

    async doRead(_ctx, payload) {
      const res = await ApiUtils.postData({
        data: [
          {
            api: "M0010SettingService.M21201_getEdit",
            input: payload || {},
          },
        ],
      });
      // 様々なAPIレスポンス形式を適切に処理する（M21201_doBrowse_AtDataTableと同様）
      const output = res?.[0]?.output ?? res?.data ?? res?.output ?? res;
      return output;
    },

    async doAdd(_ctx, payload) {
      const res = await ApiUtils.postData({
        data: [
          {
            api: "M0010SettingService.M21201_doAdd",
            input: payload || {},
          },
        ],
      });
      const output =
        res?.[0]?.output ?? res?.doAdd?.output ?? res?.output ?? res;
      return output;
    },

    async doEdit(_ctx, payload) {
      const res = await ApiUtils.postData({
        data: [
          {
            api: "M0010SettingService.M21201_doEdit",
            input: payload || {},
          },
        ],
      });
      const output =
        res?.[0]?.output ?? res?.doEdit?.output ?? res?.output ?? res;
      return output;
    },
    // 互換性アクション：フロントエンドの Edit.vue から M21201/doSaveUpdate として呼び出される
    // ページモード、または setting_no の有無に応じて doEdit (更新) か doAdd (新規作成) へルーティングする
    async doSaveUpdate(_ctx, payload) {
      if (payload && payload.__pageMode === "add") {
        return await _ctx.dispatch("doAdd", payload);
      }
      if (payload && payload.setting_no) {
        return await _ctx.dispatch("doEdit", payload);
      }
      return await _ctx.dispatch("doAdd", payload);
    },

    async doBatchEdit(_ctx, rows = []) {
      const res = await ApiUtils.postData({
        data: [
          {
            api: "M0010SettingService.M21201_doBatchEdit",
            input: rows || [],
          },
        ],
      });
      const output =
        res?.[0]?.output ?? res?.doBatchEdit?.output ?? res?.output ?? res;
      return output;
    },

    async saveOrder({ dispatch }, rows = []) {
      // 非推奨：代わりに doBatchEdit を使用してください
      return await dispatch("doBatchEdit", rows);
    },
  },
};

export default ObjArrUtils.merge(Base, error, BREAD, module);
